<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :title="factory.pkId ? '编辑' : '新建'"
    width="600px"
    @close="$reset('form')"
  >
    <el-form ref="form" :model="factory" :rules="ruleValidate" class="form" label-width="80px">
      <el-form-item v-if="factory.pkId" label="工厂编号">
        <el-input v-model="factory.factoryNo" disabled />
      </el-form-item>
      <el-form-item label="工厂名称" prop="factoryName">
        <el-input v-model.trim="factory.factoryName" placeholder="请输入工厂名称" />
      </el-form-item>
      <el-form-item label="工厂简称">
        <el-input v-model.trim="factory.shortName" placeholder="请输入工厂简称" />
      </el-form-item>
      <el-form-item label="工厂地址">
        <el-input v-model.trim="factory.address" placeholder="请输入工厂地址" />
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="submitHandle">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      submitLoading: false,
      factory: {
        pkId: 0,
        factoryName: "",
        shortName: "",
        address: "",
      },
      ruleValidate: {
        factoryName: { required: true, message: "请输入工厂名称", trigger: "blur" },
      },
    };
  },
  methods: {
    open(row) {
      this.dialogVisible = true;
      if (row) {
        this.factory = Object.assign(this.factory, row);
      }
    },

    // 确定
    submitHandle() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitLoading = true;
          this.$http
            .save("basic", "factorys", this.factory)
            .then((resp) => {
              this.submitLoading = false;
              if (resp.success) {
                if (this.factory.pkId) {
                  this.$emit("save-success");
                  this.$message.success("编辑成功");
                } else {
                  this.$emit("save-success");
                  this.$message.success("添加成功");
                }
                this.dialogVisible = false;
              }
            })
            .catch(() => {
              this.submitLoading = false;
            });
        }
      });
    },
  },
};
</script>
